module.exports = __webpack_public_path__ + "assets/fonts/212c8ce9-e668-4bbf-ab50-783ebeaa2d8a.014f9ed4.woff2";